import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Box, Button, InputAdornment, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from 'use-toast-mui';
import GoBackIcon from '../../_icons/GoBackIcon';
import { createOperator, getAllMenu, getOperatorById, updateOperator } from '../../api/menu';
import { checkUserName } from '../../api/user';
import { activeYn } from '../../constants/constants';
import { FormInputPhone } from '../../form-components/FormInputPhone';
import { FormInputRadio } from '../../form-components/FormInputRadio';
import { FormInputText } from '../../form-components/FormInputText';
import { errorMessages } from '../../utils/methods';
import MenuSelect from './MenuSelect';
import { useParams } from 'react-router-dom';

const SetUserDetail = ({}) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');

  const token = useSelector(function (state) {
    return state.user.user.token;
  });
  const toast = useToast();

  const { handleSubmit, register, setValue, watch, control, setError, clearErrors } = useForm({
    defaultValues: {
      name: '',
      username: '',
      phoneNumber: '',
      email: '',
      password: '',
      status: 'ACTIVE',
      representativeMenus: [],
    },
  });
  const { fields, append, update, remove } = useFieldArray({
    control,
    name: 'representativeMenus',
  });
  const [menuData, setMenuData] = useState(null);

  const inputProps = {
    control: control,
    color: 'info',
    required: true,
    variant: 'outlined',
    size: 'small',
    sx: { mt: '10px', width: '400px' },
  };

  const LabelStyle = {
    mt: '20px',
    color: '#0F7F85',
    fontWeight: 500,
    fontSize: '12px',
  };

  const handleCheckId = async () => {
    const username = watch('username');
    try {
      const exist = await checkUserName({ username: username });

      if (exist) {
        setError('username', { type: 'custom', message: t('Already Used') });
        setSuccessMessage(''); // Clear success message if username exists
      } else {
        setSuccessMessage(t('You can use this username')); // Show success message if username is available
        clearErrors('username'); // Clear any error messages
      }
    } catch (error) {
      // Handle any errors that may occur
      console.error(error);
    }
  };

  const getMenu = async () => {
    try {
      const data = await getAllMenu(token);
      setMenuData(data);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const getOperator = async () => {
    try {
      const data = await getOperatorById(id, token);
      for (const [key, value] of Object.entries(data)) {
        if (key !== 'representativeMenus') {
          setValue(`${key}`, value);
        } else {
          value.map((menu, index) => {
            const parentId = menu.menuId;
            if (menu.subMenus.length > 0) {
              menu.subMenus.map((submenu, subindex) => {
                const pushMenu = {
                  parentId: parentId,
                  menuId: submenu.menuId,
                  accessType: submenu.accessType,
                };
                append(pushMenu);
              });
            } else {
              const pushMenu = {
                parentId: parentId,
                menuId: null,
                accessType: menu.accessType,
              };
              append(pushMenu);
            }
          });
        }
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const handleAddPermission = () => {
    append({
      parentId: null,
      menuId: null,
      accessType: 'READ',
    });
  };

  const handleRepMenus = data => {
    // get unique parentId from representativeMenus where menuId is not null
    const uniqueParentIds = [...new Set(data.filter(item => item.menuId !== null).map(item => item.parentId))];
    const parents = uniqueParentIds.map(item => {
      return {
        menuId: item,
        accessType: 'READ',
      };
    });
    const elementsWithNullMenuId = data.filter(item => item.menuId === null);
    const normalElements = data.filter(item => item.menuId !== null);

    const parentsWithoutChilds = elementsWithNullMenuId.map(item => {
      return {
        menuId: item.parentId,
        accessType: item.accessType,
      };
    });
    const childs = normalElements.map(item => {
      return {
        menuId: item.menuId,
        accessType: item.accessType,
      };
    });
    const combinedArray = parents.concat(parentsWithoutChilds, childs);
    return combinedArray;
  };

  const submit = async values => {
    const { ...filterValues } = values;
    filterValues.representativeMenus = handleRepMenus(filterValues.representativeMenus);

    if (!id) {
      if (values.password !== values.verifyPassword) {
        return setError('verifyPassword', {
          type: 'custom',
          message: t('Password not matched'),
        });
      }
      try {
        const response = await createOperator(filterValues, token);
        toast.success(t('Save completed'));
        navigate('/operators');
      } catch (error) {
        toast.error(errorMessages(error));
      }
    } else {
      try {
        const response = await updateOperator(filterValues, id, token);
        toast.success(t('Update completed'));
        navigate('/operators');
      } catch (error) {
        toast.error(errorMessages(error));
      }
    }
  };

  const asyncCaller = async () => {
    await getMenu();

    if (id) {
      await getOperator();
    } else {
      const menuWatch = watch('representativeMenus');
      if (menuWatch.length == 0) {
        handleAddPermission();
      }
    }
  };

  useEffect(() => {
    asyncCaller();
  }, []);

  return (
    <div
      key={'0'}
      style={{
        background: 'white',
        borderRadius: '5px',
        padding: '40px',
        width: '1058px',
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Link to="/operators" style={{ textDecoration: 'none', color: '#3a3a3a', display: 'flex' }}>
          <GoBackIcon />
          <Typography sx={{ fontSize: '18px', ml: '8px', fontWeight: '550' }}>{t('Add Admin')}</Typography>
        </Link>

        <Link
          style={{
            color: '#0F7F85',
            textDecoration: 'none',
            fontWeight: 550,
            fontSize: '14px',
          }}
          to="/operators">
          {t('List')}
        </Link>
      </Box>
      <Box className="form1" sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flex: '0 0 50%' }}>
          <Typography sx={LabelStyle}>{t('Name*')}</Typography>
          <FormInputText
            {...inputProps}
            name="name"
            rules={{ required: true }}
            placeholder={t('Enter executor name')}
          />

          <Typography sx={LabelStyle}>{t('Email')}</Typography>
          <FormInputText {...inputProps} name="email" type="email" placeholder={t('Please enter your email')} />

          <Typography sx={LabelStyle}>{t('Password')}</Typography>
          <FormInputText
            {...inputProps}
            rules={{
              required: !id,
              pattern: {
                value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{}|;:'",.<>?/-]).{8,16}$/,
                message: t(
                  'Please enter your password (8 to 16 characters including English letters, numbers, and special characters)',
                ),
              },
            }}
            name="password"
            type="password"
            placeholder={t(
              'Please enter your password (8 to 16 characters including English letters, numbers, and special characters)',
            )}
          />
        </Box>
        <Box sx={{ flex: '0 0 50%' }}>
          <Typography sx={LabelStyle}>{t('ID*')}</Typography>
          <Box
            sx={{
              display: 'flex',
              maxWidth: '400px',
              height: '40px',
              marginTop: '10px',
            }}>
            <FormInputText
              {...inputProps}
              rules={{ required: true }}
              sx={{ ...inputProps.sx, '.MuiInputBase-root': { pr: '0px' }, marginTop: '0px', marginRight: '5px' }}
              name="username"
              placeholder={t('Please enter your ID')}
            />

            <Button
              onClick={handleCheckId}
              sx={{
                width: '100px',
                height: '40px',
                fontSize: '13px',
                '&:hover': { background: '#0F7F85', color: '#fff' },
              }}
              variant="contained">
              {t('Confirm')}
            </Button>
          </Box>
          {successMessage && (
            <p
              style={{
                color: '#0F7F85',
                fontWeight: '400',
                fontSize: '0.75rem',
                textAlign: 'left',
                marginTop: '4px',
                marginLeft: '14px',
                marginBottom: '0px',
              }}>
              {successMessage}
            </p>
          )}

          <Typography
            sx={{
              mt: successMessage ? '0px' : '20px',
              color: '#0F7F85',
              fontWeight: 500,
              fontSize: '12px',
            }}>
            {t('Phone Number*')}
          </Typography>
          <FormInputPhone
            {...inputProps}
            setValue={setValue}
            name="phoneNumber"
            rules={{ required: true }}
            placeholder={t('Enter your phone number')}
          />

          <Typography sx={LabelStyle}>{t('Confirm Password')}</Typography>
          <FormInputText
            {...inputProps}
            setValue={setValue}
            name="verifyPassword"
            rules={{ required: !id }}
            type="password"
            placeholder={t(
              'Please enter your password (8 to 16 characters including English letters, numbers, and special characters)',
            )}
          />
        </Box>
      </Box>
      <Typography
        sx={{
          mt: '20px',
          color: '#0F7F85',
          fontWeight: 500,
          fontSize: '12px',
        }}>
        {t('Set Part Permissions')}
      </Typography>

      {fields.map((item, index) => (
        <Box
          sx={{
            borderRadius: '5px',
            width: '1000px',
            padding: '20px',
            background: '#fafbfc',
            mb: '11px',
            mt: '11px',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <MenuSelect key={item.id} data={item} menuData={menuData} index={index} control={control} remove={remove} />
        </Box>
      ))}
      <Box
        onClick={() => handleAddPermission()}
        sx={{
          display: 'inline-flex',
          columnGap: '10px',
          '&:hover': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
          },
        }}>
        <ControlPointIcon color="#707070" />
        <Typography>{t('Add Permission')}</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '50px', mb: '25px' }}>
        <Typography sx={LabelStyle}>{t('Use or not')}</Typography>
        <FormInputRadio style={{ mt: '20px' }} row={true} name="status" control={control} options={activeYn} />
      </Box>
      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          mb: '50px',
          mt: '12.5px',
        }}>
        <Button
          sx={{
            borderRadius: '12px',
            pl: '35px',
            pr: '35px',
            mr: '6px',
            background: '#f7f7f7',
            width: '100px',
            height: '36px',
            color: '#9a9a9a',
            border: 'none',
            '&:hover': { background: '#ddd' },
          }}>
          {t('Cancel')}
        </Button>
        <Button
          onClick={handleSubmit(submit)}
          sx={{
            width: '137px',
            height: '36px',
            borderRadius: '12px',
            pl: '50px',
            pr: '50px',
            background: '#faf7fe',
            '&:hover': { background: '#0F7F85', color: '#fff' },
          }}>
          {t('Save')}
        </Button>
      </Box>
    </div>
  );
};

export default SetUserDetail;
